import angular from 'angular';

import './icon-palette.style.sass';
import template from './icon-palette.tpl.pug';

class IconPaletteController {
    $onInit() {
        this.page = 0;
    }

    $onChanges(changeObject) {
        if (changeObject.icons && changeObject.icons.currentValue) {
            let icons = changeObject.icons.currentValue || [];

            this.icons = icons.map((icon) => angular.merge({}, icon));
        }

        this.updateSelectedIcon(this.icons || [], this.iconIndex);
        this.iconForegroundColor = this.getReadableTextColor(this.iconColor);

        if (this.page > this.pageCount - 1) {
            this.page = this.pageCount - 1;
        }
    }

    updateSelectedIcon(icons, iconIndex) {
        icons.forEach((icon) => {
            icon.selected = icon.iconIndex === iconIndex;
        });
    }

    get pageSize() {
        return (this.columns || 7) * (this.rows || 4);
    }

    get pageCount() {
        if (!this.icons || this.icons.length === 0) {
            return 1;
        }

        return Math.ceil(this.icons.length / this.pageSize);
    }

    get visibleIcons() {
        const size = this.pageSize;
        const start = this.page * size;
        return (this.icons || []).slice(start, start + size);
    }

    goPreviousPage() {
        if (this.page > 0) {
            this.page -= 1;
        }
    }

    goNextPage() {
        if (this.page < this.pageCount - 1) {
            this.page += 1;
        }
    }

    select(icon) {
        if (!this.disabled) {
            this.$ctrl.$setViewValue(icon.iconIndex);
            this.updateSelectedIcon(this.icons || [], icon.iconIndex);

            return this.onChange({
                icon
            });
        }
    }

    getReadableTextColor(backgroundColor) {
        const rgb = this.parseColorToRgb(backgroundColor);
        if (!rgb) {
            return '#fff';
        }

        const [r, g, b] = rgb.map((value) => {
            const channel = value / 255;
            return channel <= 0.03928
                ? channel / 12.92
                : Math.pow((channel + 0.055) / 1.055, 2.4);
        });

        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return luminance > 0.5 ? '#394852' : '#fff';
    }

    parseColorToRgb(color) {
        if (!color || typeof color !== 'string') {
            return null;
        }

        let value = color.trim();
        if (value[0] === '#') {
            value = value.slice(1);
        }

        if (value.length === 3) {
            const red = parseInt(value[0] + value[0], 16);
            const green = parseInt(value[1] + value[1], 16);
            const blue = parseInt(value[2] + value[2], 16);
            return [red, green, blue];
        }

        if (value.length === 6) {
            const red = parseInt(value.slice(0, 2), 16);
            const green = parseInt(value.slice(2, 4), 16);
            const blue = parseInt(value.slice(4, 6), 16);
            return [red, green, blue];
        }

        return null;
    }
}

export default {
    selector: 'dbAIconPalette',
    template: template(),
    controller: IconPaletteController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        iconIndex: '<ngModel',
        iconColor: '<',
        icons: '<',
        disabled: '<ngDisabled',
        rows: '<',
        columns: '<',
        onChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/component/icon-palette/icon-palette.cmpt.js